import React from "react";

import "./DeleteTableIcon.scss";

const DeleteTableIcon = ({ disabled }) => (
  <svg
    id="Delete_Row_Dark_Theme_"
    data-name="Delete Row (Dark Theme)"
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    className={`parent-Delete-Table${disabled ? " delete-table-disabled" : ""}`}
  >
    <rect id="Margin" width="34" height="34" fill="none" />
    <circle id="Ellipse_284" data-name="Ellipse 284" cx="7.5" cy="7.5" r="7.5" transform="translate(8.5 8.5)" className="delete-table-cls1" />
    <line id="Line_212" data-name="Line 212" x2="8" transform="translate(12 16)" className="delete-table-cls2" />
  </svg>
);

export default DeleteTableIcon;
